/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThemeProvider } from '@one-thd/sui-atomic-components';
import { getThemeByName } from '@thd-olt-component-react/stencil-themes';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import LinksContent from './LinksContent';
import LinksSkeleton from './LinksSkeleton';
import QuickLinksProvider from './QuickLinksContext';
import { dataModel } from '../util/data-model';

const QuickLinks = ({
  componentId = '', linkList = undefined, slotContentId = '', mediaCollectionIndex = 0,
  theme = undefined, label = undefined, disablePadding = false,
  pillVariant = 'outline', livePreviewData = null
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('quick-links.ready'); }, []);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const data = {
    name: 'QuickLinks',
    component: 'QuickLinks',
    type: 'content',
    position: 1,
    id: componentId
  };

  // Padding is optional: a consumer whose own page layout already reserves space around this
  // component can drop it here instead of stacking two sources of spacing.
  const wrapperClasses = classnames(
    'sui-flex sui-bg-primary',
    { 'sui-py-4 md:sui-py-6': !disablePadding }
  );

  return (
    <ThemeProvider theme={getThemeByName(theme)}>
      <ImpressionProvider data={data}>
        <div className={wrapperClasses} data-component="QuickLinks">
          {
            mounted ? (
              <QuickLinksProvider
                componentId={componentId}
                linkList={linkList}
                slotContentId={slotContentId}
                mediaCollectionIndex={mediaCollectionIndex}
                label={label}
                pillVariant={pillVariant}
                livePreviewData={livePreviewData}
              >
                <LinksContent />
              </QuickLinksProvider>
            ) : (
              <LinksSkeleton />
            )
          }
        </div>
      </ImpressionProvider>
    </ThemeProvider>
  );
};

QuickLinks.displayName = 'QuickLinks';
QuickLinks.dataModel = dataModel;

QuickLinks.propTypes = {
  label: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }),
  componentId: PropTypes.string,
  linkList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
    openInNewTab: PropTypes.bool,
    onClick: PropTypes.func,
  })),
  slotContentId: PropTypes.string,
  mediaCollectionIndex: PropTypes.number,
  theme: PropTypes.string,
  disablePadding: PropTypes.bool,
  pillVariant: PropTypes.oneOf(['outline', 'filled']),
  livePreviewData: PropTypes.shape({
    linkListCollection: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        href: PropTypes.string,
        label: PropTypes.string,
      })),
    }),
  }),
};

export { QuickLinks };
